import { Component, ElementRef, OnInit } from '@angular/core';
import {
  EpBasePanelComponent,
  EpComponentSharedService,
  EpShellService,
  IEpRadioButtonData,
  IEpSlidingPanelComponentModel
} from '@epicor/ux-platform';
import { Router } from '@angular/router';
import { AuthorizationHeader, AuthorizationHeaderProcessing, HeaderTypes, ICallHeader } from '../models/headers';
import { AppLocalizationStrings } from '../app.localization.strings';

export interface ISetHeaderPanelModel extends IEpSlidingPanelComponentModel {
  headerType: HeaderTypes;
  headerValue: ICallHeader;
  canEditName: boolean;
}

@Component({
  selector: 'app-set-header',
  templateUrl: './set-header.component.html',
  styleUrls: ['./set-header.component.scss']
})
export class SetHeaderComponent extends EpBasePanelComponent<ISetHeaderPanelModel> implements OnInit {
  appStrings = AppLocalizationStrings;

  public radioBtnAuthorizationHeader: Array<IEpRadioButtonData> = [
    { value: AuthorizationHeaderProcessing.SkipHeader, label: this.appStrings.radSkipAuthHeader },
    { value: AuthorizationHeaderProcessing.UseBasicAuth, label: this.appStrings.radBasicAuth },
    { value: AuthorizationHeaderProcessing.UseHeaderValue, label: this.appStrings.radHeaderValue }
  ];

  constructor(
    elementRef: ElementRef,
    epComponentShared: EpComponentSharedService,
    private router: Router,
    private epShellService: EpShellService
  ) {
    super(elementRef, epComponentShared);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  activate() {
    super.activate();
    this.epShellService.setTitle(this.model.headerType);
  }

  deactivate() {
    super.deactivate();
    this.epShellService.setTitle('');
  }

  getDefaultModel(): ISetHeaderPanelModel {
    return {
      objectName: 'SetHeaderComponent',
      configKey: 'SetHeaderComponent',
      headerValue: { Name: '', Value: '' },
      headerType: HeaderTypes.ApiKey,
      canEditName: false,
      onOkHandler: result => {},
      onCancelHandler: () => {}
    };
  }

  returnHeader() {
    this.model.onOkHandler('OK');
  }

  shouldShowTextBox() {
    return this.model.headerType === HeaderTypes.ApiKey;
  }

  shouldShowCallSettings() {
    return this.model.headerType === HeaderTypes.CallSettings;
  }

  shouldShowLicense() {
    return this.model.headerType === HeaderTypes.License;
  }

  shouldShowSessionInfo() {
    return this.model.headerType === HeaderTypes.SessionInfo;
  }

  shouldShowCallInfo() {
    return this.model.headerType === HeaderTypes.CallInfo;
  }

  shouldShowAuthorization() {
    return this.model.headerType === HeaderTypes.Authorization;
  }

  shouldShowBasicAuth() {
    const auth = <AuthorizationHeader>this.model.headerValue;
    return auth.Value.ProcessingType === AuthorizationHeaderProcessing.UseBasicAuth;
  }

  shouldShowAuthHeaderValue() {
    const auth = <AuthorizationHeader>this.model.headerValue;
    return auth.Value.ProcessingType === AuthorizationHeaderProcessing.UseHeaderValue;
  }
}
